import { AxiosError } from 'axios';
import {
  ReduxExtensionsRegistrationState,
  ReduxAppState
} from '../../core/store'
import { IUserProfile } from '../interfaces';

export interface ReduxUserProfileState {
  userProfile: IUserProfile;
  isLoading: boolean;
  error: AxiosError;
}

export interface ReduxToDoCrudState {
  isLoading: boolean;
  error: AxiosError;
}

export interface ReduxRootState {
  app: ReduxAppState;
  extensionsRegistration: ReduxExtensionsRegistrationState;
  userProfile: ReduxUserProfileState;
  todoCrud: ReduxToDoCrudState;
}


export const FETCH_USER_PROFILE_BEGIN = 'FETCH_USER_PROFILE_BEGIN';
export const FETCH_USER_PROFILE_SUCCESS = 'FETCH_USER_PROFILE_SUCCESS';
export const FETCH_USER_PROFILE_FAILURE = 'FETCH_USER_PROFILE_FAILURE';

export const SET_USER_PROFILE_BEGIN = 'SET_USER_PROFILE_BEGIN';
export const SET_USER_PROFILE_SUCCESS = 'SET_USER_PROFILE_SUCCESS';
export const SET_USER_PROFILE_ERROR = 'SET_USER_PROFILE_ERROR';
